module.exports = __webpack_public_path__ + "static/media/add-reactions.f2548930.svg";